/* Ishwar Tattva motion layer, built on Framer Motion (framer-motion 14.2.0 dom-mini build, window.Motion.animate).
   Today it does one thing the CSS layer cannot: when something is added to the bag, the bag icon in the header gives a short confirming pulse.
   The hero, product pop-ins and section reveals stay in CSS (itx.css, itx-lux.css), because they already animate and a second animation would fight them.
   Stands down for visitors who ask for reduced motion, and does nothing if Framer Motion fails to load.
   This file is loaded before pubsub.js, so it waits for DOMContentLoaded, by which time every deferred script has run. */
(function(){
  var M=window.Motion;
  if(!M||!M.animate)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;

  function init(){
    if(typeof subscribe!=='function'||typeof PUB_SUB_EVENTS==='undefined')return;
    subscribe(PUB_SUB_EVENTS.cartUpdate,function(){
      /* the header re-renders the bag icon after the cart changes, so look it up a moment later */
      setTimeout(function(){
        var bag=document.getElementById('cart-icon-bubble');
        if(bag)M.animate(bag,{scale:[1,1.22,1]},{duration:0.55,ease:'easeOut'});
      },350);
    });
  }
  if(document.readyState==='complete')init();else document.addEventListener('DOMContentLoaded',init);
})();
